import { render, staticRenderFns } from "./DealStatusPill.vue?vue&type=template&id=967ae1a6&"
import script from "./DealStatusPill.vue?vue&type=script&lang=js&"
export * from "./DealStatusPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports